import { useForm } from 'react-hook-form'
import { Toggle } from 'ComponentLibrary/src/atoms/Toggle/Toggle'
import { Stack } from '@mui/material'

type SelectCellFormType = {
    isOn: boolean
}

type SelectCellProps = {
    onToggle: (newValue: boolean) => void
    disabled?: boolean
} & SelectCellFormType

export function EditableToggleCell({ isOn, onToggle, disabled }: SelectCellProps) {
    const { handleSubmit } = useForm<SelectCellFormType>({
        defaultValues: { isOn },
    })

    const onSubmit = handleSubmit((formData) => {
        onToggle(!formData.isOn)
    })

    return (
        <Stack width="24px" marginRight="-16px" alignItems="center">
            <Toggle onToggle={onSubmit} isOn={isOn} disabled={disabled} />
        </Stack>
    )
}
